/**
 * `/chat-dev/trace-demo` — dev-only fixture playground for the
 * <ToolTrace> primitive (Stream C addendum §5).
 *
 * URL note (deviation from addendum §5): the addendum specified
 * `/_chat/trace-demo` as the literal URL, but TanStack's file-based
 * router treats a single leading underscore as a "pathless layout"
 * marker (folders/files starting with `_` are consumed from the URL
 * and used only for layout composition). The literal-underscore-
 * segment shape is not expressible without escaping into the
 * programmatic route API, which is a much heavier change. We deviate
 * to `/chat-dev/trace-demo` and keep the same intent (dev-only
 * surface, env-guarded). Flagged in the PR description.
 *
 * The guard inside the page component falls through to a "not
 * available" stub in non-DEV builds, so any production user typing
 * the URL by hand sees a polite empty state rather than a crash.
 *
 * Wave-17 Item 1.1 — lazy-loaded; never shipped to production users.
 */
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/chat-dev/trace-demo")({
  component: lazyRouteComponent(() => import("@/pages/Portal/TraceDemo/Page")),
});
